import { useQuery } from '@tanstack/react-query';

import { IWebhookStaticConfig } from '../types';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

type ImperativeRequestFn = ReturnType<typeof useImperativeRequestWrapper>[1];

const getStaticConfig = async ({
  makeRequest,
}: {
  makeRequest: ImperativeRequestFn;
}): Promise<IWebhookStaticConfig> => {
  const { data, error } = await makeRequest({
    path: '/webhooks/static-config',
    method: 'get',
  });
  if (error) throw new Error(error?.message ?? String(error));

  return data;
};

type QueryFnType = typeof getStaticConfig;

export const useGetStaticConfig = (config?: QueryConfig<QueryFnType>) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    staleTime: 5 * 60 * 1000,
    ...config,
    queryKey: ['webhook-static-config'],
    queryFn: () => getStaticConfig({ makeRequest }),
  });
};
